import React, { ComponentProps } from 'react';
import { UserProfileSelection } from '../../_lib/components/UserProfileSelection/UserProfileSelection';
import ILink from '../../types/ILink';
import IUrl from '../../types/IUrl';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';

type UserAccountProps = {
  profileName: string;
  profileLink: ILink;
  logoutUrl: IUrl;
  disableReadAllModeUrl?: IUrl;
  enableReadAllModeUrl?: IUrl;
};
function UserAccount({
  profileName,
  profileLink,
  logoutUrl,
  disableReadAllModeUrl,
  enableReadAllModeUrl,
}: UserAccountProps) {
  const { t } = useSonTranslation('UserAccount');

  return (
    <UserProfileSelection
      headline={t('userAccountFor', {
        profileName,
      })}
      profileLink={profileLink?.url}
      profileLinkText={t('links.myProfile')}
      logoutLink={logoutUrl?.url}
      logoutLinkText={t('links.logout')}
      disableReadAllModeLink={disableReadAllModeUrl?.url}
      disableReadAllModeLinkText={t('links.disableReadAllMode')}
      enableReadAllModeLink={enableReadAllModeUrl?.url}
      enableReadAllModeLinkText={t('links.enableReadAllMode')}
    />
  );
}

export const UserAccountBlock = asBlock(UserAccount, BlockType.useraccount);
export type UserAccountBlock = ComponentProps<typeof UserAccountBlock>;
